import type { NextPage } from "next";

import { StaticHeader, StaticPage } from "@components/StaticPage";

const PRIVACY_TEXT = `Luma Labs, Inc. (“us”, “we”, or “our”) operates glow.app, Glow browser extension, and Glow mobile apps (the “Service”). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Service.

We use your Personal Information only for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy.

## Information Collection And Use

While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name and email address (“Personal Information”).

We make it clear to you throughout the Service when we share your personal data with third-parties. We have no control over, and are not responsible or liable for the ways those third-parties use your personal data.

## Log Data

Like many site operators, we collect information that your browser sends whenever you visit our Service (“Log Data”).

This Log Data may include information such as your computer’s Internet Protocol (“IP”) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics. In addition, we may use third party services such as Google Analytics that collect data about your visit.

## Cookies

Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer’s hard drive.

Like many sites, we use “cookies” to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.

## Security

The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.

## Data Retention

We retain your personal data in order to provide a consistent service. We retain different types of data for different lengths depending on the type of data and what it is used for. We will retain your Personal Information for the period necessary to fulfill obligations to the law.

## Third-Party Web Sites and Applications

The Service contains links to third-party web sites and applications. Clicking on these links may allow those third parties to collect data about you. We do not control such web sites and applications and are not responsible for how they collect or use your data.

## Your Rights

Where and when required by the law, you have the right to request access, correction or erasure of your personal data. We may need to request information from you to confirm your identity.

If while using the Service, you grant us access to any external account of yours, you may revoke such access at any time and we will delete the associated data.

## Changes To This Privacy Policy

This Privacy Policy is effective as of April 6, 2020 and will remain in effect except with respect to any changes in
its provisions in the future, which will be in effect immediately after being posted on this page.

We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.

If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.

## Contact Us

If you have any questions about this Privacy Policy, please email us at
[support@glow.app](mailto:support@glow.app).`;

const Privacy: NextPage = () => {
  return (
    <StaticPage
      title="Privacy Policy"
      path="/privacy-policy"
      header={
        <StaticHeader
          title="Privacy Policy"
          subtitle="Last updated: May 11, 2022"
        />
      }
      markdown={PRIVACY_TEXT}
    />
  );
};

export default Privacy;
